import { isSuccess } from '@devexperts/remote-data-ts'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '@/store/configureStore'
import { extraSlice } from '@/store/extraSlice'
import { cartSlice } from '..'

const isUsingCartInfoDataSelector = (
  _: RootState,
  isUsingCartInfoData?: boolean
) => isUsingCartInfoData

export const selectTotalPrice = createSelector(
  [
    cartSlice.selectors.cartDetailPrices,
    cartSlice.selectors.quoteWithDiscount,
    cartSlice.selectors.quote,
    isUsingCartInfoDataSelector,
  ],
  (cartDetail, quoteWithDiscount, quote, isUsingCartInfoData): number => {
    if (isUsingCartInfoData) {
      return cartDetail?.totalPrice ?? 0
    }
    if (isSuccess(quoteWithDiscount)) {
      return quoteWithDiscount.value.totalPrice
    }
    if (isSuccess(quote)) {
      return quote.value.totalPrice
    }
    return 0
  }
)

export const selectWeatherInsurancePrice = createSelector(
  [
    cartSlice.selectors.cartDetail,
    extraSlice.selectors.weatherInsurancePricePreview,
    isUsingCartInfoDataSelector,
  ],
  (cartDetail, weatherInsurancePricePreview, isUsingCartInfoData) => {
    if (isUsingCartInfoData && isSuccess(cartDetail)) {
      return cartDetail.value.cart.weatherPolicy?.price ?? 0
    }
    if (isSuccess(weatherInsurancePricePreview)) {
      return weatherInsurancePricePreview.value
    }
    return 0
  }
)

export const selectTotal = createSelector(
  [
    cartSlice.selectors.isWeatherInsuranceAddedToCart,
    selectTotalPrice,
    selectWeatherInsurancePrice,
  ],
  (isWeatherInsuranceAddedToCart, totalPrice, weatherInsurancePrice) => {
    if (isWeatherInsuranceAddedToCart) {
      return totalPrice + weatherInsurancePrice
    }
    return totalPrice
  }
)
